import React, { useState, useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
    Box, Button, FormControl, FormLabel, FormErrorMessage,
    Input, Stack, IconButton, Modal,
    ModalOverlay, ModalContent, ModalHeader, ModalBody,
    ModalCloseButton, Text, useToast,
    Spinner
} from '@chakra-ui/react';
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import axiosInstance from '../../services/axios';
import ReactSelect from 'react-select';
import CustomSelect from '../../utils/CustomSelect';

const TrackInfo = ({ storefront, platform, track, onClose, onTrackCreated }) => {
    const toast = useToast();
    const [imageloading, setImageLoading] = useState(false);
    const [trackLoading, setTrackLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [, setSuccess] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [trackFile, setTrackFile] = useState(null);
    const [supportedCountries, setSupportedCountries] = useState([
        { value: 'US', label: 'United States' }
    ]);


    const genres = [
        'Afrobeats', "AfroGospel", 'AfroRave', 'AfroFusion', 'EmoAfrobeats', 'Street-Hop',
        'Pon Pon Music', 'AfroLife', 'Highlife', 'Kuduro', 'Afrocongo',
        'Gqom', 'Azonto', 'Rock', 'Hard Rock', 'Soft Rock', 'Progressive Rock',
        'Punk Rock', 'Alternative Rock', 'Jazz', 'Bebop', 'Swing', 'Fusion',
        'Free Jazz', 'Smooth Jazz', 'Classical', 'Baroque', 'Romantic',
        'Modern', 'Classical Period', 'Contemporary Classical', 'Hip Hop',
        'Rap', 'Trap', 'Gangsta Rap', "Gospel", 'Conscious Hip Hop', 'East Coast Hip Hop',
        'West Coast Hip Hop', 'Electronic', 'House', 'Techno', 'Dubstep',
        'Trance', 'Drum and Bass', 'Ambient', 'Pop', 'Teen Pop', 'Dance Pop',
        'Synth-pop', 'Electropop', 'Pop Rock', 'R&B', 'Contemporary R&B',
        'Soul', 'Funk', 'Disco', 'New Jack Swing', 'Country', 'Bluegrass',
        'Honky Tonk', 'Outlaw Country', 'Country Pop', 'Alternative Country',
        'Reggae', 'Roots Reggae', 'Dub', 'Dancehall', 'Ska', 'Rocksteady'
    ].map(genre => ({ value: genre, label: genre }));

    function formatDateFromISO(isoDateString) {
        let date = new Date(isoDateString);
        let year = date.getFullYear();
        let month = ("0" + (date.getMonth() + 1)).slice(-2);
        let day = ("0" + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }


    const handleWheel = (event) => {
        event.target.blur(); // Removes focus to prevent scroll behavior
    };

    function getImageFromTrack() {
        if (platform === "spotify") {
            return track.album.images[0].url
        } else if (platform === "apple") {
            return `${track.attributes.artwork.url.slice(0, track.attributes.artwork.url.length - 14)}/${track.attributes.artwork.width}x${track.attributes.artwork.height}bb.jpg`
        } else {
            return ""
        }
    }

    const { register, handleSubmit, setValue, formState: { errors }, watch, control } = useForm();
    const formData = watch()
    const [trackDetails, setTrackDetails] = useState({
        streaming_platforms: [
            {
                platform: platform,
                id: track?.id || "",
            },
        ],
        image_url: getImageFromTrack(),
        preview_url: "",
        track_url: "",
        track_status: "reviewing",
    });

    useEffect(() => {
        const updatedDetails = { ...trackDetails };
        updatedDetails.streaming_platforms[0].platform = platform;
        updatedDetails.streaming_platforms[0].id = track.id;
        setTrackDetails(updatedDetails);
    }, [imageFile, platform, track.id, trackDetails]);

    useEffect(() => {
        const fetchSupportedCountries = async () => {
            try {
                const response = await axiosInstance.get('/music/supported_countries');
                setSupportedCountries(response.data);
                // Set default country value
                setValue('country', response.data[0]?.value);
            } catch (error) {
                console.error('Error fetching supported countries:', error);
                // Keep fallback countries
            }
        };
        
        fetchSupportedCountries();
    }, [setValue]);

    useEffect(() => {
        const fetchTrackDetails = async () => {
            console.log(platform, track);
            try {
                if (platform === 'spotify') {
                    setValue('artist_name', track.artists.map(artist => artist.name).join(', '));
                    setValue('track_name', track.name);
                    setValue('album_name', track.album.name);
                    // setValue('album_id', track.album.id);
                    setValue('image_url', track.album.images[0].url);
                    setValue('album_type', 'single');
                    setValue('isrc', track.external_ids?.isrc || '');
                    setValue('release_date', track.album.release_date);
                    setValue('spotify_popularity', track.popularity || 0);
                    // setTrackDetails({ ...trackDetails, image_url: track.album.images[0].url })
                    setTrackDetails({ ...trackDetails, preview_url: track.preview_url ? track.preview_url : "" })
                } else if (platform === 'apple') {
                    setValue('artist_name', track.attributes.artistName);
                    setValue('track_name', track.attributes.name);
                    setValue('album_name', track.attributes.albumName);
                    // setValue('album_id', track.relationships.albumName.data[0].id || "");
                    setValue('image_url', `${track.attributes.artwork.url.slice(0, track.attributes.artwork.url.length - 14)}/${track.attributes.artwork.width}x${track.attributes.artwork.height}bb.jpg`);
                    setValue('album_type', 'single');
                    setValue('release_date', track.attributes.releaseDate);
                    setValue('isrc', track.attributes.isrc || '');
                    // setTrackDetails({ ...trackDetails, image_url: `${track.attributes.artwork.url.slice(0, track.attributes.artwork.url.length - 14)}/${track.attributes.artwork.width}x${track.attributes.artwork.height}bb.jpg` })
                    setTrackDetails({ ...trackDetails, preview_url: track.attributes.previews[0].url })
                } else {
                    throw new Error('Invalid platform provided');
                }
            } catch (error) {
                console.error('Error fetching track data:', error);
            }
        };
        fetchTrackDetails();
    }, [track, trackDetails, platform, storefront, setValue]);




    const handleImageUpload = async (file) => {
        if (!file) return;
        setImageFile(file);
        setImageLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post(`/music/upload/file?artist=${trackDetails.artist_name}`, formData);
            setTrackDetails({ ...trackDetails, image_url: response.data });

            toast({
                title: 'Image Uploaded Successfully',
                status: 'success',
                isClosable: true,
                duration: 3000,
            });
        } catch (error) {
            toast({
                title: 'Error Uploading Image',
                description: error.message,
                status: 'error',
                isClosable: true,
                duration: 3000,
            });
        } finally {
            setImageLoading(false);
        }
    };

    const handleTrackUpload = async (file) => {
        if (!file) return;
        setTrackFile(file);
        setTrackLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post(`/music/upload/track/s3?bucket=beatstake-stream&artist=${trackDetails.artist_name}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setTrackDetails({ ...trackDetails, track_url: response.data });

            toast({
                title: 'Track Uploaded Successfully',
                status: 'success',
                isClosable: true,
                duration: 3000,
            });
        } catch (error) {
            toast({
                title: 'Error Uploading Track',
                description: error.message,
                status: 'error',
                isClosable: true,
                duration: 3000,
            });
        } finally {
            setTrackLoading(false);
        }
    };

    const handleImageDelete = () => {
        setTrackDetails({ ...trackDetails, image_url: getImageFromTrack() });
        setImageFile("")
        toast({
            title: 'Image Deleted',
            status: 'info',
            isClosable: true,
            duration: 3000,
        });
        document.getElementById('file-upload').value = null;

    };

    const handleTrackDelete = () => {
        setTrackDetails({ ...trackDetails, track_url: '' });
        setTrackFile(""); // Clear selected file name
        toast({
            title: 'Track Deleted',
            status: 'info',
            isClosable: true,
            duration: 3000,
        });
        document.getElementById('track-upload').value = null;

    };



    const onSubmit = async (data) => {

        setLoading(true);
        setError(null);
        setSuccess(false);




        data = { ...data, streaming_platforms: trackDetails.streaming_platforms, track_status: trackDetails.track_status, available_shares: data.num_of_shares, genres: data.genres, track_url: trackDetails.track_url, preview_url: trackDetails.preview_url, spotify_popularity: data.spotify_popularity };
        data.release_date = new Date(data.release_date).toISOString();
        data.genres = formData.genres.map(gen => gen.value);
        data.image_url = trackDetails.image_url;

        console.log(data)


        try {


            const response = await axiosInstance.post('/music/create_track', data);
            setSuccess(true);
            onClose();
            console.log(response.data)
            onTrackCreated();
            toast({
                title: "Track created successfully.",
                status: "success",
                duration: 3000,
                isClosable: true,
            });


        } catch (error) {
            setError(error.message || 'An error occurred');
            toast({
                title: "An error occurred.",
                description: error.message || "Failed to create track.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleAddPlatform = () => {
        setTrackDetails(prevState => ({
            ...prevState,
            streaming_platforms: [...prevState.streaming_platforms, { platform: '', id: '' }]
        }));
    };

    const handleRemovePlatform = (index) => {
        setTrackDetails(prevState => ({
            ...prevState,
            streaming_platforms: prevState.streaming_platforms.filter((_, idx) => idx !== index)
        }));
    };

    const handlePlatformChange = (index, field, value) => {
        setTrackDetails(prevState => ({
            ...prevState,
            streaming_platforms: prevState.streaming_platforms.map((platform, idx) =>
                idx === index ? { ...platform, [field]: value } : platform
            )
        }));
    };

    const handleGenresChange = (selectedOptions) => {
        setValue('genres', selectedOptions);
    };

    const handleCountryChange = (selectedOption) => {
        setValue('country', selectedOption.value);
    };


    return (
        <Modal isOpen={true} onClose={onClose} size="xl">
            {console.log(formData)}
            <ModalOverlay />
            <ModalContent borderRadius="xl">
                <ModalHeader textAlign="center" fontWeight="bold">Create Shares</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <img src={trackDetails.image_url} alt="Track Artwork" width="200px" />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Stack spacing={3}>
                            <FormControl>
                                <Input
                                    type="file"
                                    display="none"
                                    id='file-upload'
                                    onChange={(e) => handleImageUpload(e.target.files[0])}
                                    accept="image/*"
                                />
                                <Button as="label" htmlFor="file-upload" variant="brand" my={3} bg={trackDetails.image_url && imageFile && !imageloading ? "green.300" : "dark.900"}>
                                    {imageloading ? <Spinner size="sm" /> : trackDetails.image_url && imageFile ? '✔' : "change image"}
                                </Button>
                                <Text>{imageFile?.name}</Text>
                                {trackDetails.image_url && !imageloading && imageFile && (
                                    <Button
                                        variant="outline"
                                        colorScheme="red"
                                        onClick={handleImageDelete}

                                    >
                                        Delete
                                    </Button>
                                )}
                            </FormControl>

                            <FormControl>
                                <FormLabel>Upload Track Preview (MP3 or WAV)</FormLabel>
                                <Input
                                    type="file"
                                    display="none"
                                    accept=".mp3,.wav"
                                    id='track-upload'
                                    onChange={(e) => handleTrackUpload(e.target.files[0])}
                                />
                                <Button as="label" htmlFor="track-upload" variant="brand" bg={trackDetails.track_url && trackFile && !trackLoading ? "green.300" : "dark.900"}>
                                    {trackLoading ? <Spinner size="sm" /> : trackDetails.track_url ? '✔' : '+'}
                                </Button>
                                {trackDetails.track_url && !trackLoading && (
                                    <Button
                                        variant="outline"
                                        colorScheme="red"
                                        onClick={handleTrackDelete}
                                        ml={2}
                                    >
                                        Delete
                                    </Button>
                                )}
                                <Text>{trackFile?.name}</Text>
                            </FormControl>
                            <FormControl isInvalid={errors.artist_name}>
                                <FormLabel>Artist Name</FormLabel>
                                <Input type="text" {...register('artist_name', { required: true })} defaultValue={trackDetails.artist_name} variant="light" />
                                <FormErrorMessage>{errors.artist_name && "Artist name is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.track_name}>
                                <FormLabel>Track Name</FormLabel>
                                <Input type="text" {...register('track_name', { required: true })} defaultValue={trackDetails.track_name} variant="light" />
                                <FormErrorMessage>{errors.track_name && "Track name is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl>
                                <FormLabel>ISRC</FormLabel>
                                <Input type="text" {...register('isrc')} variant="light" />
                            </FormControl>
                            {platform === 'spotify' && (
                                <FormControl>
                                    <FormLabel>Spotify Popularity (0-100)</FormLabel>
                                    <Input type="number" min="0" max="100" {...register('spotify_popularity')} variant="light" />
                                </FormControl>
                            )}
                            <FormControl>
                                <FormLabel>Streaming Platforms</FormLabel>
                                <Stack spacing={2}>
                                    {trackDetails.streaming_platforms.map((pf, index) => (
                                        <Box key={index} display="flex" alignItems="center">
                                            <CustomSelect
                                                flex="1"
                                                value={pf.platform}
                                                onChange={(val) => handlePlatformChange(index, 'platform', val)}
                                                placeholder="Select Platform"
                                                variant="light"
                                            >
                                                <option value="apple">Apple Music</option>
                                                <option value="spotify">Spotify</option>
                                                <option value="Amazon Music">Amazon Music</option>
                                                <option value="Youtube Music">Youtube Music</option>
                                                <option value="Tidal">Tidal</option>
                                                <option value="Deezer">Deezer</option>
                                                <option value="Pandora">Pandora</option>
                                            </CustomSelect>
                                            <Input
                                                flex="3"
                                                ml={2}
                                                value={pf.id}
                                                onChange={(e) => handlePlatformChange(index, 'id', e.target.value)}
                                                placeholder="Track ID"
                                                variant="light"
                                            />

                                            {index > 0 && (
                                                <IconButton
                                                    ml={2}
                                                    icon={<MinusIcon />}
                                                    onClick={() => handleRemovePlatform(index)}
                                                    colorScheme="red"
                                                />
                                            )}
                                        </Box>
                                    ))}
                                    <Button onClick={handleAddPlatform} leftIcon={<AddIcon />} color="dark.900" borderColor="dark.900" variant="solid">
                                        Add Platform
                                    </Button>
                                </Stack>
                            </FormControl>
                            <FormControl isInvalid={errors.album_name}>
                                <FormLabel>Album Name</FormLabel>
                                <Input type="text" {...register('album_name', { required: true })} defaultValue={trackDetails.album_name} variant="light" />
                                <FormErrorMessage>{errors.album_name && "Album name is required"}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={!!errors.album_type}>
  <FormLabel>Album Type</FormLabel>

  <Controller
    name="album_type"
    control={control}
    rules={{ required: true }}
    render={({ field }) => (
      <CustomSelect
        value={field.value}
        onChange={field.onChange}
        placeholder="Select album type"
        variant="light"
        width="100%"
      >
        <option value="single">Single</option>
        <option value="ep">EP</option>
        <option value="album">Album</option>
      </CustomSelect>
    )}
  />

  <FormErrorMessage>
    {errors.album_type && 'Album type is required'}
  </FormErrorMessage>
</FormControl>
                            <FormControl isInvalid={errors.release_date}>
                                <FormLabel>Release Date</FormLabel>
                                <Input type="date" {...register('release_date', { required: true })} defaultValue={formatDateFromISO(trackDetails.release_date)} variant="light" />
                                <FormErrorMessage>{errors.release_date && "Release date is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.total_track_percent_for_sale}>
                                <FormLabel>Percentage of stream revenue you are selling</FormLabel>
                                <Input type="number" onWheel={handleWheel} {...register('total_track_percent_for_sale', { required: true })} variant="light" />
                                <FormErrorMessage>{errors.total_track_percent_for_sale && "Total track percent for sale is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.num_of_shares}>
                                <FormLabel>streamshares to offer</FormLabel>
                                <Input type="number" onWheel={handleWheel} {...register('num_of_shares', { required: true })} variant="light" />
                                <FormErrorMessage>{errors.num_of_shares && "Number of streamshares is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.price_per_share}>
                                <FormLabel>price per streamshare</FormLabel>
                                <Input
                                    {...register('price_per_share', {
                                        required: "Price per share is required",
                                        validate: (value) => {
                                            const floatValue = parseFloat(value);
                                            return !isNaN(floatValue) || "Price per share must be a valid number";
                                        }
                                    })}
                                    variant="light"
                                />
                                <FormErrorMessage>{errors.price_per_share && errors.price_per_share.message}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.share_limit}>
                                <FormLabel>streamshare limit per person</FormLabel>
                                <Input type="number" onWheel={handleWheel} {...register('share_limit', { required: true })} variant="light" />
                                <FormErrorMessage>{errors.share_limit && "Share limit is required"}</FormErrorMessage>
                            </FormControl>
                            <FormControl isInvalid={errors.genres}>
                                <FormLabel>Genres</FormLabel>
                                <ReactSelect
                                    {...register('genres', { required: true })}
                                    options={genres}
                                    isMulti
                                    onChange={handleGenresChange}
                                />
                                <FormErrorMessage>{errors.genres && "At least one genre is required"}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.country}>
                                <FormLabel>Country</FormLabel>
                                <ReactSelect
                                    {...register('country', { required: true })}
                                    options={supportedCountries}
                                    onChange={handleCountryChange}
                                    placeholder="Select Country"
                                    defaultValue={supportedCountries[0]}
                                />
                                <FormErrorMessage>{errors.country && "Country selection is required"}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={errors.ownership_term}>
                                <FormLabel>Ownership term (minimum 5 years)</FormLabel>
                                <Input type="number" onWheel={handleWheel} {...register('ownership_term', { required: true, min: 5 })} variant="light" />
                                <FormErrorMessage>{errors.ownership_term && "Ownership term must be at least 5"}</FormErrorMessage>
                            </FormControl>
                            {error && <Text color="red.500">{error}</Text>}
                            <Button type="submit" isLoading={loading} colorScheme="blue">Create Shares</Button>
                        </Stack>
                    </form>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default TrackInfo;
